<template>
  <section id="articles">
    <Header :class="{header: true, hidden: hideHeader}"
      v-on:login="$emit('login')" :scrolled="true"/>
    <div class="loading" v-if="loading"></div>
    <div v-else class="sectionCnt">
      <div class="sectionHeader">
        <h2>Pesan dan Kreasi</h2>
        <div class="searchCnt">
          <input type="text" class="search" placeholder="Search...">
          <button class="searchBtn"></button>
        </div>
      </div>
      <div class="tab" v-if="1>2">
        <div :class="{tabItem: true, active: tabActive === 'article'}"
          v-on:click="selectTab('article')">Teks</div>
        <div :class="{tabItem: true, active: tabActive === 'image'}"
          v-on:click="selectTab('image')">Visual</div>
        <div :class="{tabItem: true, active: tabActive === 'video'}"
          v-on:click="selectTab('video')">Audio Visual</div>
      </div>
      <div class="noData" v-if="!results || results.length < 1">
        <h4>Belum ada pesan kreasi</h4>
        <p>Submit pesan dan kreasi kamu untuk ditampilkan disini.</p>
      </div>
      <div class="sectionSm" v-else :class="tabActive">
        <div class="sItem" v-for="(item, i) in results" :key="i">
          <div class="sItemIn">
            <div v-on:click="viewContent(item)">
              <div class="sImg" :style="{backgroundImage: `url(${item.thumb})`}"
                v-if="item.thumb">
                <div class="playIcon" v-if="item.type === 'video'"></div>
                <div class="multipleImg" v-if="item.type === 'image' && item.images
                  && item.images.length > 1"></div>
              </div>
              <div class="sImg noImg" v-else>
                <div class="playIcon" v-if="item.type === 'video'"></div>
                <div class="multipleImg" v-if="item.type === 'image' && item.images
                  && item.images.length > 1"></div>
              </div>
            </div>
            <div class="sInfo">
              <div v-on:click="viewContent(item)">
                <h4>{{item.title.substr(0, 46)}}<span
                  v-if="item.title.length > 46">...</span></h4>
                <p>{{item.description.substr(0, 106)}}<span
                  v-if="item.description.length > 106">...</span></p>
              </div>
              <div class="type" v-if="item.type === 'video'">Audio Visual</div>
              <div class="type" v-else-if="item.type === 'image'">Visual</div>
              <div class="type" v-else>{{item.type}}</div>
              <div class="creator viewMember" v-if="item.isGroup === 1">
                Kreator: {{item.group.name}}
                <span v-on:click="viewGroupMember(item)">Lihat anggota</span>
              </div>
              <div class="creator" v-else-if="item.author && item.author.name">
                Kreator: {{item.author.name}}</div>
              <div class="creator" v-else>
                Kreator: Unknown</div>
            </div>
          </div>
        </div>
      </div>
      <div class="submitPesan" v-on:click="submitPesan">
        Submit Pesan dan Kreasimu
      </div>
    </div>
    <GroupMember ref="groupMember"/>
    <LoadingDialog ref="loadingDialog"/>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Header from '@/components/Header.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import GroupMember from '@/components/GroupMember.vue';

export default {
  name: 'home',
  components: { Header, LoadingDialog, GroupMember },
  data() {
    return {
      loading: true,
      hideHeader: false,
      tabActive: 'article',
    };
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'chMenuActive',
    ]),
    viewContent(item) {
      if (item.type === 'image') {
        this.$viewerApi({
          options: {
            title: false,
            movable: false,
            zoomOnWheel: false,
            slideOnTouch: true,
          },
          images: item.imagesUri,
        });
        return;
      }
      this.$router.push(`/bicara-bumi/pesan-dan-kreasi/${item.type}/${item.slug}`);
    },
    viewGroupMember(item) {
      this.$refs.groupMember.open(item);
    },
    selectTab(tab) {
      this.tabActive = tab;
      this.$refs.loadingDialog.open();
      this.getData();
    },
    submitPesan() {
      if (!this.$session.get('jwt')) {
        localStorage.setItem('submitPesan', 'YES');
        this.$emit('login');
        return;
      }
      this.$router.push('/bicara-bumi/pesan-dan-kreasi/submit');
    },
    getData() {
      this.loading = true;
      this.results = [];
      this.$http.get(this.$config.uri('article/user/all')).then((r) => {
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.loading = false;
        this.$refs.loadingDialog.close();
      });
    },
  },
  mounted() {
    this.page = this.$route.params.slug;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Pesan dan Kreasi - Bumi Butuh Aksi';
    if (localStorage.getItem('submitPesan') === 'YES') {
      localStorage.setItem('submitPesan', null);
      this.$router.push('/bicara-bumi/pesan-dan-kreasi/submit');
      return;
    }
    this.chMenuActive('bicara-bumi');
    this.getData();
  },
};
</script>

<style scoped lang="scss">
#articles{
  min-height: 100vh;
  background-color: #f4f6f1;
  box-sizing: border-box;
  padding-top: 80px;
}

.sectionCnt{
  max-width: 1240px;
  margin: 0 auto;
  @media (max-width: 1300px) {
    max-width: none;
    margin: 0 20px;
  }
  @media (max-width: 680px) {
    margin: 0 16px;
  }
}

.noData{
  padding: 18px;
  background-color: #eaece5;
  h4{
    font-size: 24px;
    margin: 0 0 4px;
  }
  p{
    margin: 0;
  }
}

.sectionHeader{
  border-bottom: #999 2px solid;
  position: relative;
  padding: 60px 0 10px;
  margin-bottom: 24px;
  @media (max-width: 1200px) {
    padding-top: 30px;
  }
  @media (max-width: 960px) {
    padding-top: 20px;
    border-bottom: none;
    margin-bottom: 10px;
  }
  @media (max-width: 680px) {
    padding-top: 0;
  }
  h2{
    font-size: 64px;
    font-weight: 800;
    margin: 0;
    @media (max-width: 1200px) {
      font-size: 46px;
    }
    @media (max-width: 680px) {
      font-size: 34px;
      margin-bottom: 4px;
    }
  }
  .searchCnt{
    position: absolute;
    right: 0; top: 80px;
    @media (max-width: 1200px) {
      top: 34px;
    }
    @media (max-width: 960px) {
      position: relative;
      right: auto; top: auto;
    }
    input{
      border: none;
      background-color: #fff;
      font-size: 16px;
      padding: 10px 20px;
      line-height: 1;
      border-radius: 50px;
      border: #ddd 1px solid;
      width: 300px;
      @media (max-width: 960px) {
        width: 100%;
        box-sizing: border-box;
      }
      @media (max-width: 680px) {
        padding: 8px 20px;
      }
    }
    button{
      position: absolute;
      border: none;
      background-color: #fff;
      width: 30px; height: 30px;
      right: 10px; top: 4px;
      background-image: url(../assets/loupe.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .6;
    }
  }
}
.tab{
  display: flex;
  margin-bottom: 30px;
  @media (max-width: 960px) {
    border-bottom: #999 2px solid;
  }
  .tabItem{
    // margin-right: 40px;
    text-transform: uppercase;
    font-weight: 800;
    cursor: pointer;
    font-size: 17px;
    border-bottom: transparent 3px solid;
    padding: 0 20px 4px;
    color: #767676;
    @media (max-width: 960px) {
      border-width: 2px;
      margin-bottom: -2px;
    }
    @media (max-width: 680px) {
      font-size: 14px;
      padding-left: 16px;
      padding-right: 16px;
    }
    &:hover{
      border-color: #ccc;
      color: #444;
    }
    &.active{
      border-color: #009b4b;
      color: #009b4b;
    }
  }
}
.sectionSm{
  display: flex;
  margin: 0 -15px;
  flex-wrap: wrap;
  @media (max-width: 680px) {
    margin: 0;
  }
  .sItem{
    width: 25%;
    box-sizing: border-box;
    padding: 0 15px;
    margin-bottom: 30px;
    color: #444;
    @media (max-width: 960px) {
      width: 33.33333%;
    }
    @media (max-width: 680px) {
      width: 100%;
      padding: 0;
    }
    .sItemIn{}
    .sImg{
      height: 200px;
      cursor: pointer;
      background-color: #999;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      @media (max-width: 1200px) {
        height: 160px;
      }
      @media (max-width: 680px) {
        height: 200px;
      }
      &.noImg{
        background-image: url(../assets/image-black.png);
        background-size: 46px auto;
        opacity: .3;
      }
      .playIcon{
        width: 64px; height: 64px;
        background-image: url(../assets/play-white-hd.png);
        background-size: 64px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        left: 50%; top: 50%;
        margin: -32px 0 0 -32px;
        opacity: .8;
      }
      .multipleImg{
        width: 40px; height: 40px;
        background-image: url(../assets/page-white.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 40px auto;
        position: absolute;
        right: 10px; top: 10px;
      }
      &:hover{
        .playIcon{
          opacity: 1;
        }
      }
    }
    .sInfo{
      padding: 10px 2px 20px;
      a{
        text-decoration: none;
        color: #444;
      }
      h4{
        margin: 0 0 6px;
        font-size: 24px;
        cursor: pointer;
        line-height: 1.1;
      }
      p{
        margin: 0;
        font-size: 16px;
        cursor: pointer;
        line-height: 1.2;
      }
      .type{
        margin: 14px 0 0;
        text-transform: uppercase;
        font-weight: 800;
        color: #767676;
        font-size: 14px;
      }
      .creator{
        font-size: 14px;
        font-weight: 600;
        &.viewMember{
          span{
            color: #12855e;
            cursor: pointer;
            margin-left: 5px;
          }
        }
      }
    }
  }
  &.image{
    .sItem{
      width: 33.333333%;
      @media (max-width: 680px) {
        width: 100%;
      }
      .sImg{
        height: 340px;
        @media (max-width: 1200px) {
          height: 260px;
        }
        @media (max-width: 960px) {
          height: 200px;
        }
        @media (max-width: 680px) {
          height: 260px;
        }
      }
    }
  }
  &.video{
    .sItem{
      width: 50%;
      @media (max-width: 680px) {
        width: 100%;
      }
      .sImg{
        height: 340px;
        @media (max-width: 960px) {
          height: 240px;
        }
        @media (max-width: 680px) {
          height: 200px;
        }
      }
    }
  }
}
.submitPesan{
  display: inline-block;
  margin: 20px 0 80px;
  padding: 12px 20px;
  font-size: 18px;
  font-weight: 800;
  padding-left: 64px;
  position: relative;
  cursor: pointer;
  transition: all .3s ease;
  color: #444;
  text-decoration: none;
  &:hover{
    background-color: #e6e8e1;
  }
  &:before{
    content: "";
    width: 40px;
    position: absolute;
    left: 10px; top: 0; bottom: 0;
    background-image: url(../assets/plus-circle.png);
    background-size: 36px auto;
    background-position: center;
    background-repeat: no-repeat;
    opacity: .8;
  }
}

.loading{
  position: absolute;
  top: 80px; left: 0; right: 0; bottom: 0;
  background-image: url(../assets/loading.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
